// extracted by mini-css-extract-plugin
export default {"form":"CloudPayments_form__2aOEm","buttons_block":"CloudPayments_buttons_block__y+tVv","button":"CloudPayments_button__F-Wpg"};